import * as classnames from 'classnames'
import * as React from 'react'

import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import FilterList from '../../../components/filterList'
import ChevronUpIcon from '../../../components/icons/chevronUp'
import FilterItem from '../selectedFilters/filterItem'

import * as styles from './index.module.css'

interface IProps {
  children: React.ReactNode
  id: string
  title: string
  expanded?: boolean
  togglePanel?: any
  togglePanelOptions?: any
  locationParams: ILocationParams
  filterOptionsCount: number
  hasShowMoreOnMobile: boolean
  loading: boolean
  optionsAreCollapsed?: any
}

interface IFilterNamesMapping {
  [propName: string]: string
}

const filterNamesMapping: IFilterNamesMapping = {
  'compatible-with': 'compatible_with',
  'software-version': 'platform',
  'date-added': 'date'
}

const visibleFilterOptionsLimit = 6

const ExpandingFilterPanel = ({
  children,
  id,
  title,
  expanded,
  togglePanel,
  togglePanelOptions,
  optionsAreCollapsed,
  locationParams,
  filterOptionsCount,
  hasShowMoreOnMobile,
  loading
}: IProps) => {
  const limitFilterHeight =
    hasShowMoreOnMobile && filterOptionsCount > visibleFilterOptionsLimit

  const root = classnames(styles.filterContainer, {
    [styles.disableFilter]: loading
  })

  const toggleButtonStyle = classnames(styles.buttonToggle, {
    [styles.buttonToggleActive]: expanded
  })

  const filtersStyle = classnames(styles.optionsWrapper, {
    [styles.hideFilters]: !expanded,
    [styles.optionsCollapsed]: limitFilterHeight && optionsAreCollapsed
  })

  const hiddenOptionsCount = filterOptionsCount - visibleFilterOptionsLimit
  const showMoreVisible =
    hasShowMoreOnMobile &&
    limitFilterHeight &&
    expanded &&
    hiddenOptionsCount > 0

  let matchedParams = Object.keys(locationParams).filter((param: any) =>
    param.match(filterNamesMapping[id] || id)
  )

  // if price_min and price_max are selected at the same time, only show one of them.
  if (locationParams.price_min && locationParams.price_max) {
    matchedParams = matchedParams.filter(
      (filter: any) => filter !== 'price_min'
    )
  }

  // if length_min and length_max are selected at the same time, only show one of them.
  if (locationParams.length_min && locationParams.length_max) {
    matchedParams = matchedParams.filter(
      (filter: any) => filter !== 'length_min'
    )
  }

  const parsedParam = matchedParams.length === 1 ? matchedParams.pop() : ''

  return (
    <div className={root} data-test-selector={`filter-${id}`}>
      <button
        className={toggleButtonStyle}
        onClick={togglePanel.bind(undefined, id, expanded)}
        type="button"
        aria-label={`Click to ${expanded ? 'collapse' : 'expand'}`}
      >
        <div className={styles.headingContainer}>
          <h3 className={styles.heading}>{title}</h3>
          <FilterList
            FilterItem={FilterItem}
            parsedLocation={locationParams}
            param={parsedParam}
            className={styles.appliedFilters}
            interactive={false}
          />
          <ChevronUpIcon width="13" height="8" />
        </div>
      </button>
      <div className={filtersStyle}>{children}</div>
      {showMoreVisible && (
        <span
          role="button"
          className={styles.optionsCollapsedToggle}
          onClick={togglePanelOptions.bind(undefined, id)}
        >
          Show {optionsAreCollapsed ? `More (${hiddenOptionsCount})` : 'Less'}
        </span>
      )}
    </div>
  )
}

export default ExpandingFilterPanel
